import { justForSideEffectWithPayload } from '../../infrastructure/saga.helpers'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  BasicQueryState, GetAddressByBatchParams, GetAddressDetailParams, GetBatchDetailParams, GetProductBatchDetailParams,
} from './BasicQueriesTypes'

const initialState: BasicQueryState = {}

const getAddressByBatch = justForSideEffectWithPayload<GetAddressByBatchParams>()
const getBatchDetail = justForSideEffectWithPayload<GetBatchDetailParams>()
const getAddressDetail = justForSideEffectWithPayload<GetAddressDetailParams>()
const getAddressInfo = justForSideEffectWithPayload<string>()
const getProductDetail = justForSideEffectWithPayload<GetProductBatchDetailParams>()
const getProductInfoByBarcode = justForSideEffectWithPayload<string>()

const setBatchInfo = (
  state: BasicQueryState,
  { payload }: PayloadAction<BasicQueryState['batchInfo']>,
): BasicQueryState => ({
  ...state,
  batchInfo: payload,
})

const setBatchDetail = (
  state: BasicQueryState,
  { payload }: PayloadAction<BasicQueryState['batchDetails']>,
): BasicQueryState => ({
  ...state,
  batchDetails: payload,
})

const setProductBatchInfo = (
  state: BasicQueryState,
  { payload }: PayloadAction<BasicQueryState['productInfo']>,
): BasicQueryState => ({
  ...state,
  productInfo: payload,
})

const setProductBatchDetail = (
  state: BasicQueryState,
  { payload }: PayloadAction<BasicQueryState['productDetail']>,
): BasicQueryState => ({
  ...state,
  productDetail: payload,
})

const setAddressInfo = (
  state: BasicQueryState,
  { payload }: PayloadAction<BasicQueryState['addressInfo']>,
): BasicQueryState => ({
  ...state,
  addressInfo: payload,
})

const setAddressDetail = (
  state: BasicQueryState,
  { payload }: PayloadAction<BasicQueryState['addressDetails']>,
): BasicQueryState => ({
  ...state,
  addressDetails: payload,
})

const clearState = (): BasicQueryState => initialState

const slice = createSlice({
  name: 'basicQuery',
  initialState,
  reducers: {
    setBatchInfo,
    getAddressByBatch,
    setBatchDetail,
    getBatchDetail,
    setAddressInfo,
    getAddressInfo,
    getAddressDetail,
    setAddressDetail,
    setProductBatchInfo,
    getProductInfoByBarcode,
    setProductBatchDetail,
    getProductDetail,
    clearState,
  },
})

export default slice.reducer

export const { actions } = slice
